module.exports = __webpack_public_path__ + "img/xiaozi_yixie.f4356820.png";